export default __webpack_public_path__ + "assets/_Chapters/_Images/background/PSA-Vollversorgung/7.webp";